export const TRANSACTION_STATUS = {
  SUCCESS: "success",
  PENDING: "pending",
  CANCEL: "cancel",
};
